import React, { useEffect } from "react";
import "./Visiting_Cards.css";
import Shop_by_shapes from "./Shop_by_shapes/Shop_by_shapes";
import Shop_by_papers_textures from "./Shop_by_papers_textures/Shop_by_papers_textures";
import Shop_specialty_business from "./Shop_specialty_business/Shop_specialty_business";
import Creative_ways from "./Creative_ways/Creative_ways";
import BannerComponent from "../Common-Component/BannerComponent/BannerComponent";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  getAllProductsMetarial,
  getAllProductsShape,
} from "../../features/products/productsSlice";

function Visiting_Cards() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  const subcategory = searchParams.get("subcategory");
  const childcategory = searchParams.get("childcategory");
  const image = searchParams.get("image");
  const need = searchParams.get("need");

  const categoryId = searchParams.get("category_id");
  const subcategoryId = searchParams.get("sub_category_id");
  const childcategoryId = searchParams.get("child_category_id");

  const need_id = searchParams.get("need_id");

 
  const dispatch = useDispatch();
  const productdataShape = useSelector(
    (state) => state.product.allProductsShape
  );
  useEffect(() => {
    dispatch(
      getAllProductsShape({
        type: "shape",
        need_id: need_id,
        category_id: categoryId,
        subcategory_id: subcategoryId,
        childcategory_id: childcategoryId,
      })
    );
  }, [dispatch, categoryId, subcategoryId, childcategoryId, need_id]);

  const productdataMaterial = useSelector(
    (state) => state.product.allProductsMetarial
  );
  useEffect(() => {
    dispatch(
      getAllProductsMetarial({
        type: "material",
        need_id: need_id,
        category_id: categoryId,
        subcategory_id: subcategoryId,
        childcategory_id: childcategoryId,
      })
    );
  }, [dispatch, categoryId, subcategoryId, childcategoryId, need_id]);

  const productdataSpecialty = useSelector(
    (state) => state.product.allProducts
  );
  useEffect(() => {
    dispatch(
      getAllProducts({
        type: "specialty",
        need_id: need_id,
        category_id: categoryId,
        subcategory_id: subcategoryId,
        childcategory_id: childcategoryId,
      })
    );
  }, [dispatch, categoryId, subcategoryId, childcategoryId, need_id]);

  const productdata = useSelector(
    (state) => state.product.allProducts
  );
  useEffect(() => {
    dispatch(
      getAllProducts({
        need_id: need_id,
        category_id: categoryId,
        subcategory_id: subcategoryId,
        childcategory_id: childcategoryId,
      })
    );
  }, [dispatch, categoryId, subcategoryId, childcategoryId, need_id]);

 
  return (
    <section className="Visiting_Cards">
      <BannerComponent
        img={ process.env.REACT_APP_IMG_URL + image ||"/assets/Images/Visiting_Cards/Banner/banner_img_1.png"}
        title={category || subcategory || childcategory || need}
      />

      {productdata.length > 0 && (
        <Shop_by_shapes productdata={productdata} />
      )}

      {productdataMaterial.length > 0 && (
        <Shop_by_papers_textures productdata={productdataMaterial} />
      )}

      {productdataSpecialty.length > 0 && (
        <Shop_specialty_business productdata={productdataSpecialty} />
      )}

      <Creative_ways />
    </section>
  );
}

export default Visiting_Cards;
